// Extension to handle blob images in Quill editor
// * Supports `blob:...` URLs
// * Support data-content-id attribute.

// Usage:
//    quill.insertEmbed(index, "blobImage", { src, contentId })

import Quill from "quill"
const ImageBlot = Quill.import("formats/image")

class BlobImage extends ImageBlot {
  static blotName = "blobImage"

  static create(value) {
    let node = super.create(value)
    if (typeof value === "object") {
      node.setAttribute("src", value.src)
      node.dataset.contentId = value.contentId
    }
    return node
  }

  static value(node) {
    return {
      src: node.getAttribute("src"),
      contentId: node.dataset.contentId,
    }
  }
}

Quill.register(BlobImage)
